import { type SVGProps } from 'react';

export function StarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.6228 18.5254C26.6228 22.1152 29.533 25.0254 33.1228 25.0254H45.8752C46.4134 25.0254 46.8496 25.4616 46.8496 25.9998C46.8496 26.5379 46.4134 26.9741 45.8752 26.9741H33.1228C29.533 26.9741 26.6228 29.8843 26.6228 33.4741V46.2234C26.6228 46.7615 26.1866 47.1978 25.6484 47.1978C25.1103 47.1978 24.6741 46.7615 24.6741 46.2234V33.4741C24.6741 29.8843 21.7639 26.9741 18.1741 26.9741H5.42163C4.8835 26.9741 4.44727 26.5379 4.44727 25.9998C4.44727 25.4616 4.8835 25.0254 5.42163 25.0254H18.1741C21.7639 25.0254 24.6741 22.1152 24.6741 18.5254V5.77612C24.6741 5.238 25.1103 4.80176 25.6484 4.80176C26.1866 4.80176 26.6228 5.238 26.6228 5.77612V18.5254Z"
        fill="currentColor"
      />
    </svg>
  );
}
